import { TransferChannelType, TransferType } from "@/common/types";
import { MessagingInProgressActionButtons } from "./MessagingInProgressActionButtons";
import { closeWhatsAppConversation } from "@/repository/queryFns";

export const WhatsAppInProgressActionButtons = () => {
	return (
		<MessagingInProgressActionButtons
			transferType={TransferType.WhatsAppAgentTransfer}
			transferIVRType={TransferType.WhatsAppTransferToQueue}
			transferChannelType={TransferChannelType.WhatsApp}
			closeInteraction={closeWhatsAppConversation}
			enablePauseButton
		/>
	);
};
